<div class="flex flex-row items-center gap-2">
  <div
    class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full"
    [style.background-color]="ecoScoreService.getColor(ecoScore)"
  >
    <img
      src="../../../assets/icons/leaf.svg"
      alt="Impact Level"
      class="h-1/2 w-1/2"
    />
  </div>
  <span class="text-sm"> {{ ecoScore }}/10 </span>
</div>
